import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
  configApiRef,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';
import { argusApiRef } from '@eng-portal/plugin-argus-common/src/argusApiRef';
import { ArgusClient, OktaTokenProvider } from '@eng-portal/plugin-argus-common';
import { oktaTokenApiRef } from '@eng-portal/czi-extensions-react';
import { MockArgusClient } from './mocks/mockArgusApi';

const argusApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: argusApiRef,
      deps: {
        configApi: configApiRef,
        oktaTokenApi: oktaTokenApiRef,
      },
      factory: ({ configApi, oktaTokenApi }) => {
        if (configApi.getOptionalBoolean('app.e2eTestMode')) {
          return new MockArgusClient();
        }
        const tokenProvider = new OktaTokenProvider(oktaTokenApi, configApi);
        return new ArgusClient(configApi, tokenProvider);
      },
    }),
});

const argusPage = PageBlueprint.make({
  params: {
    path: '/argus',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/ArgusRootPage').then(m => <m.ArgusRootPage />),
  },
});

const plugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'argus',
  extensions: [argusApi, argusPage],
  routes: {
    root: rootRouteRef,
  },
});
export default plugin;
